<template>

    <div class="layout-page chapter-detail mb0" style="min-height: 100%;"  :style="detailStyle" >

    
      <div id="scroll-div-book-read" class="aui-scrollView" style="z-index: 100; position: relative;">

        <novel-content @click.native="readSet=true" :style="detailFont" :chapterInfo="chapterInfo" ></novel-content>

        <h4>
          <div class="fb-nav" v-if="chapterInfo.bookId">
            <button
              type="button"
              :disabled="chapterInfo.number === 1"
              class="btn pre"
              @click="toLastChapter"
            >上一章</button>
            <button type="button" @click="isShowMenu=true" class="btn to-list">目录</button>
            <button
              type="button"
              :disabled="chapterInfo.number === chapterInfo.totalNumber"
              class="btn next"
              @click="toNextChapter"
            >下一章</button>
          </div>
        </h4>
      </div>

      <div class="fixed-site" v-if="readSet" @click="readSet=false" style="display: block;">

        <header class="fixed-navBar aui-navBar aui-navBar-fixed b-line">
          <a href="javascript:;" class="aui-navBar-item" @click="returnPage('back')">
            <i class="icon icon-return"></i>
          </a>
          <div class="aui-center">
            <span class="aui-center-title">{{chapterInfo.bookName}}</span>
          </div>
          <a href="javascript:;" class="aui-navBar-item navBar-right" @click="toHome">
            <i class="icon icon-home"></i>
          </a>

        </header>

        <div class="fixed-c" @click.stop>
          <h4>
            <div class="fb-nav" v-if="chapterInfo.bookId">
              <button
                type="button"
                :disabled="chapterInfo.number === 1"
                class="btn pre"
                @click="toLastChapter"
              >上一章</button>
              <button type="button" @click="isShowMenu=true" class="btn to-list">目录</button>
              <button
                type="button"
                :disabled="chapterInfo.number === chapterInfo.totalNumber"
                class="btn next"
                @click="toNextChapter"
              >下一章</button>
            </div>
          </h4>
          <div class="item">
            <span class="tl">字体</span>
            <button class="btn-font" @click="setFontSize(-1)" type="button">A-</button>
            <span class="font-s">{{font.size}}</span>
            <button class="btn-font" @click="setFontSize(1)" type="button">A+</button>
          </div>
          <div class="item">
            <span class="tl">背景</span>
            <button
              class="btn-bgc"
              type="button"
              @click="setBg('#f5f5f5')"
              style="background:#f5f5f5;"
            ></button>
            <button
              class="btn-bgc"
              type="button"
              @click="setBg('#EAFFFC')"
              style="background:#EAFFFC;"
            ></button>
            <button
              class="btn-bgc"
              type="button"
              @click="setBg('#F3FFE6')"
              style="background:#F3FFE6;"
            ></button>
            <button
              class="btn-bgc"
              type="button"
              @click="setBg('#F9E6E7')"
              style="background:#F9E6E7;"
            ></button>
          </div>
        </div>
      </div>

      <div
        class="fixed-nav"
        v-show="isShowMenu"
        @click="isShowMenu=false"
        ref="bookNavMenu"
        style="display: block;"
      >
        <div class="scroll-y" @click.stop id="bookNavMenu">
          <div class="book-detail">
            <div class="cover">
              <img style="width:auto;height:3.6rem" :bookid="chapterInfo.bookId" :booktitle="chapterInfo.bookName" :chapternum="0" :imgpath="chapterInfo.bookCover" :zoom="1000" imgtype="novel" v-lazy="require('../../../assets/images/loading.jpeg')" />
            </div>
            <div class="title">
              <h3>{{chapterInfo.bookName}}</h3>
              <span>共 {{chapterInfo.totalNumber}}章</span>
              <div class="aui-flex-box">
                <span class="i-a" v-if="chapterInfo.publishStatus == 'finish'">已完结</span>
                <span class="i-b" v-if="chapterInfo.publishStatus=='serialize'">连载中</span>
              </div>
            </div>
          </div>
          <ul class="chapter-list" id="chapter-list">
            <li v-for="item in list" :key="item.id" @click="toOneChapter(item.number)">
              <a>
                <h3 :style="item.number == $route.params.number ? 'color: #cf7a00' : ''">第{{item.number}}章 {{item.title}}</h3>
                <template v-if="item.alreadyBuy">
                  <span class="free">已购买</span>
                </template>
                <template v-else>
                  <span class="free" v-if="item.price===0">免费</span>
                  <span class="lock" v-else>{{item.price}} 阅币</span>
                </template>
              </a>
            </li>
          </ul>
          <div style="padding: 10px;text-align: center;">
            <span v-if="loading && !finished" size="24px">加载中...</span>
          </div>
        </div>
      </div>

      <div v-if="showBuy" id="buy-confirm" class="fixed-pay" style="display: block;">


        <header class="fixed-navBar aui-navBar aui-navBar-fixed b-line">
          <a href="javascript:;" class="aui-navBar-item" @click="returnPage('back')">
            <i class="icon icon-return"></i>
          </a>
          <div class="aui-center">
            <span class="aui-center-title">{{chapterInfo.bookName}}</span>
          </div>
          <a href="javascript:;" class="aui-navBar-item navBar-right" @click="toHome">
            <i class="icon icon-home"></i>
          </a>

        </header>

        <div class="fixed-c">
          <h3>本章价格：{{buyPrice}}阅读币</h3>
          <p>开通VIP，海量小说免费看</p>
          <div class="auto-pay">
            <input
              v-model="autoBuy"
              id="autoBuyCheckBox"
              type="checkbox"
              class="checkbox"
              @click="changeAutoBuy"
            />
            <span>
              <label for="autoBuyCheckBox">自动购买下一话</label>
            </span>
          </div>
          <div class="btnbox">
            <button class="btn" type="button" @click="buyChapter">购买本章节</button>
          </div>
          <p>
            <span>余额：{{userInfo.avaliableAmount}}阅读币</span>
            <a @click="goPurchase" class="f-r">开通VIP，免费阅读</a>
          </p>
        </div>
      </div>

      <div v-if="showRecharge" id="recharge-confirm" class="fixed-pay" style="display: block;">
        <div class="fixed-c">
          <h3>本章价格：{{buyPrice}}阅读币</h3>
          <div class="auto-pay">
            <input
              v-model="autoBuy"
              id="autoBuyCheckBox"
              type="checkbox"
              class="checkbox"
              @click="changeAutoBuy"
            />
            <span>
              <label for="autoBuyCheckBox">自动购买下一话</label>
            </span>
          </div>
          <div class="btnbox">
            <button class="btn" type="button" @click="goPurchase">阅币不足，前往充值</button>
          </div>
          <p>
            <span>余额：{{userInfo.avaliableAmount}}阅读币</span>
          </p>
        </div>
      </div>

      <div class="fixed-confirm" v-if="showHistoryTip && history.number" style="display: block;">
        <div class="fixed-c">
          <h3>上次阅读到第{{history ? history.number : ''}}话， 是否继续阅读？</h3>
          <div class="btnbox">
            <button class="btn" @click="toOneChapter(history.number)" type="button">确定</button>
            <button class="btn close" @click="showHistoryTip=false" type="button">取消</button>
          </div>
        </div>
      </div>

      <div class="fixed-recommend" style="display:block" v-if="recommendShow">
        <div class="fixed-c">
          <h4>不喜欢？看看小编为您推荐的热门小说</h4>
          <div class="aui-list-theme">
            <router-link
              :to="{name: 'novel-home', params: {id: item.bookId}}"
              class="aui-list-theme-item"
              v-for="item in chapterInfo.recommendList.slice(0,6)"
              :key="item.bookId"
            >
              <div class="aui-list-img">
                <img imgtype="novel"  :bookid="item.bookId" :booktitle="item.title" :chapternum="0" :imgpath="item.cover" :zoom="1000" v-lazy="require('../../../assets/images/loading.jpeg')" alt />
              </div>
              <div class="aui-list-title">
                <h3>{{item.title}}</h3>
                <div class="aui-flex">
                  <div class="aui-flex-box">
                    <span class="i-a">{{item.categoryName}}</span>
                    <!-- <span class="i-b">9.5分</span> -->
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="btnbox">
            <button class="btn" @click="jumpPage()" type="button">退出阅读</button>
            <button class="btn" @click="goOnRead" type="button">继续阅读</button>
          </div>
        </div>
      </div>

      <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'
import Alert from '@/components/share/alert'
import novelContent from '@/components/layer2/book/novel-content'
import shelfService from '../../../services/shelfService'
import novelService from '../../../services/novelService'
import scrollService from '../../../services/scrollService'
import payService from '../../../services/payService'
import userService from '../../../services/userService'
export default {
  name: 'read',
  data () {
    return {
      font: {
        size: 16,
        max: 30,
        min: 10
      },
      bg: '#FFFEF2',
      loading: false,
      finished: false,
      list: [],
      currentPage: 1,
      showHistoryTip: false,
      readSet: false,
      showBuy: false,
      showRecharge: false,
      buyPrice: 0,
      autoBuy: false,
      chapterId: 0,
      showAlert: false,
      alertMsg: '',
      isShowMenu: false,
      chapterInfo: {
        availableAmount: 0,
        bookCover: '',
        bookId: 0,
        bookName: '',
        bookPrice: '',
        bookVipFree: false,
        chapterId: 0,
        content: '',
        nextNumber: 0,
        number: 1,
        price: 0,
        title: '',
        totalNumber: 0,
        publishStatus: '',
        recommendList: []
      },
      userInfo: {},
      history: {},
      recommendShow: false,
      toPageType: 'back'
    }
  },
  methods: {
    // 继续阅读
    goOnRead () {
      this.recommendShow = false
      this.toPageType = ''
    },
    // 页面跳转
    returnPage (type, show = true) {
      this.recommendShow = show
      this.toPageType = type
    },
    toHome(){
      this.$router.isBack = this;
      this.toPageType = 'home'
      this.$router.push('/novel')
    },
    jumpPage () {
      const { toPageType } = this
      if (toPageType === 'back') {
        this.$router.isBack = true
        this.$router.go(-1)
      } else if (toPageType === 'home') {
        this.$router.isBack = false
        this.$router.push('/novel')
      }
    },
    isShowHistory () {
      const { number, id } = this.$route.params
      const hisnumber = this.history.number || 0
      const readList = this.getHistoryReadList
      const book = readList.find(item => item.bookId === id) || {
        bookId: id,
        readTipHidden: false
      }
      const bookIndex = readList.findIndex(item => item.bookId === id)
      if (hisnumber < number) {
        if (book && !book.readTipHidden) {
          this.showHistoryTip = true
          if (bookIndex > -1) {
            readList[bookIndex].readTipHidden = true
          } else {
            book.readTipHidden = true
            readList.push(book)
          }
          this.$store.commit('setHistoryReadList', readList)
        }
      }
    },
    toReadHandler (type) {
      if (type === 'history') {
      } else if (type === 'last') {
        this.toRead(this.lastChapter.number)
      }
    },
    getUserInfo () {
      this.userInfo = userService.getLocalUserInfo()
    },
    getHistory (bookId) {
      this.history = shelfService.getHistoryByIdNovel(parseInt(bookId)) || {}
      // this.isShowHistory()
    },
    getChapter (id, number) {
      novelService
        .getChapterImg(id, number)
        .then(res => {
          userService.getUserInfo()
          if (res.result) {
            this.chapterInfo = res.data
            setTimeout(() => {
              this.getBookCatalogue()
            }, 1)
            this.updateHistory()
            this.$emit('update-top-title', res.data.bookName, res.data.title)
          } else if (res.code === 999) {
            this.chapterInfo = res.data
            this.checkAutoBuy()
            this.$emit('update-top-title', res.data.bookName, res.data.title)
          } else if (res.code === 400) {
            this.alertMsg = '没有更多章节啦 ^_^ '
            this.showAlert = true
          } else if (res.code === 101) {
            userService.getUserInfo();
            this.alertMsg = '信息获取失败，请返回稍后重试';
            this.showAlert = true;
          }
        })
        .catch(() => {

          this.$dialog.confirm({
            message: '网络超时，请刷新重试'
          }).then(() => {
            this.getChapter(this.$route.params.id, this.$route.params.number)
          })
        })
    },
    getBookCatalogue () {
      const { bookId } = this.chapterInfo
      const { currentPage, loading, finished, list } = this
      if (loading || finished) return
      this.loading = true
      novelService.getChapters(bookId, currentPage).then(res => {
        const resData = res.data || {}
        const chapters = resData.chapters || []
        this.list = list.concat(chapters)
        this.loading = false
        if (chapters.length === 0 || this.list.length === resData.totalCount) {
          this.finished = true
        } else {
          this.currentPage++
        }
      })
    },
    toCatalog () {
      this.$router.isBack = false
      this.$router.push(`/novels/${this.$route.params.id}/catalog`)
    },
    toLastChapter () {
      if (this.chapterInfo.number > 1) {
        this.$router.isBack = false
        const { bookId, number } = this.chapterInfo
        this.$router.replace(`/novels/read/${bookId}/${number - 1}`)
      } else {
        this.alertMsg = '已经是第一章啦'
        this.showAlert = true
      }
      window.scrollTo({top:0})
    },
    toOneChapter (number) {
      this.$router.isBack = false
      const { bookId } = this.chapterInfo
      this.$router.replace(`/novels/read/${bookId}/${number}`)
      window.scrollTo({top:0})
    },
    toNextChapter () {
      if (this.chapterInfo.number < this.chapterInfo.totalNumber) {
        this.$router.isBack = false
        const { bookId, number } = this.chapterInfo
        this.$router.replace(`/novels/read/${bookId}/${number + 1}`)
      } else {
        this.alertMsg = '已经是最后一章啦'
        this.showAlert = true
      }
      window.scrollTo({top:0})
    },
    updateHistory () {
      const { params } = this.$route
      const { title } = this.chapterInfo
      const history = shelfService.getHistoryByIdNovel(params.id)
      if (history) {
        history.number = params.number
        history.title = title
        shelfService.updateHistoryNovel(params.id, params.number, title)
      } else {
        novelService.getDetail(this.$route.params.id).then(res => {
          if (res.data) {
            const bookInfo = res.data.novelBook
            shelfService.addHistoryNovel(bookInfo, params.number, title)
            //shelfService.addHistory(bookInfo, params.number)
          }
        })
      }
    },
    showBuyConfirm (price, chapterId) {
      this.chapterId = chapterId
      this.buyPrice = price
      this.showBuy = true
    },
    changeAutoBuy () {
      this.autoBuy = document.querySelector('#autoBuyCheckBox').checked
      if (this.autoBuy) {
        payService.addAutoBuyList(this.chapterInfo.bookId)
      } else {
        payService.removeAutoBuy(this.chapterInfo.bookId)
      }
    },
    buyChapter () {
      novelService.buyChapter(this.chapterInfo.chapterId).then(res => {
        if (res.result) {
          // 自动购买不弹出提示
          if (!payService.isAutoBuy(this.chapterInfo.bookId)) {
            this.alertMsg = '购买成功'
            this.showAlert = true
          }
          this.getChapter(this.$route.params.id, this.$route.params.number)
          this.showBuy = false
        } else if (res.code === 999) {
          this.showBuy = false
          this.showRecharge = true
        }
      })
    },
    goPurchase () {
      this.$router.isBack = false
      this.$router.push({path: `/purchase`, query: {bookId: this.chapterInfo.bookId}});
    },
    checkAutoBuy () {
      if (payService.isAutoBuy(this.chapterInfo.bookId)) {
        this.buyChapter()
      } else {
        this.showBuyConfirm(this.chapterInfo.price, this.chapterInfo.chapterId)
      }
    },
    hideBuyConfirmHandler () {
      const obj = document.getElementById('buy-confirm')
      obj.style.opacity = 1
      this.hideBuyConfirm(obj)
    },
    hideBuyConfirm (obj) {
      obj.style.opacity -= 0.05
      if (obj.style.opacity > 0) {
        setTimeout(() => {
          this.hideBuyConfirm(obj)
        }, 15)
      } else {
        this.showBuy = false
      }
    },
    navMenuScrollFn () {
      if (scrollService.isReachBottom('chapter-list')) {
        this.getBookCatalogue()
      }
    },
    setFontSize (number) {
      let size = this.font.size + number
      if (size >= 30) {
        size = 30
      } else if (size <= 10) {
        size = 10
      }
      this.font.size = size
      window.localStorage.setItem('$_read_fontsize', size)
    },
    setBg (bg) {
      this.bg = bg
      window.localStorage.setItem('$_read_bg', bg)
    },
    getReadSet () {
      const fontSize = window.localStorage.getItem('$_read_fontsize')
      const bg = window.localStorage.getItem('$_read_bg')
      if (fontSize) {
        this.font.size = parseInt(fontSize)
      }
      if (bg) {
        this.bg = bg
      }
    }
  },
  computed: {
    ...mapGetters(['getHistoryReadList']),
    detailStyle () {
      return `background:${this.bg}`
    },
    detailFont () {
      return `font-size: ${this.font.size}px`
    }
  },

  beforeRouteLeave (to, from, next) {
    if (to.name === 'purchase' || this.showBuy) next()
    const { recommendShow, toPageType } = this
    if (!toPageType || !recommendShow) {
      this.recommendShow = true
      next(false)
    } else {
      this.recommendShow = false
      this.toPageType = 'back'
      next()
    }
  },
  components: {
    alert: Alert,
    'novel-content': novelContent,
  },
  async mounted () {
    this.getReadSet()
    this.autoBuy = payService.isAutoBuy(this.$route.params.id)
    await userService.register()
    this.getUserInfo()
    this.getChapter(this.$route.params.id, this.$route.params.number)
    scrollService.addScrollListener('bookNavMenu', this.navMenuScrollFn)
    this.$router.isBack = true
    this.getHistory(this.$route.params.id)

  },
  beforeDestroy () {
    scrollService.removeScrollListener('bookNavMenu', this.navMenuScrollFn)
  }
}
</script>

<style scoped>
@import "../../../assets/css/novel.css";
.aui-scrollView{ color: #333; padding-top: 0;}

</style>




// WEBPACK FOOTER //
// src/pages/layer2/novels/read.vue